// react_frontend/src/GlobalFUnction.js
const GlobalFunction = {
    logout() {
        localStorage.clear();
        window.location.href = '/login';
    }
};

export default GlobalFunction;